export default "__VITE_ASSET__DQfcomLN__"